/** Photography generated from the standing brief in docs/IMAGE-SYSTEM.md. */
export const pricingHeroImage: { image: string; alt: string } = {
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/e15b5f21-ca44-46a5-9678-40bf54dee08b.jpg',
  alt: 'A formal printed proposal and matte black pen on a bare pale oak desk in strong morning light',
}

export const pricingClosingImage: { image: string; alt: string; caption: string } = {
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/f1f77825-63cb-4481-aea6-2002d724a29c.jpg',
  alt: 'A signed scope document, black pen and closed laptop arranged on a pale oak table from above',
  caption: 'Scope agreed in writing before anything starts.',
}

export const addOnImages: { image: string; alt: string }[] = [
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/997b3e0e-59b3-4494-be80-eded5fb47d1e.jpg',
    alt: 'Layered bone paper product cards, a black token and a muted clay square',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6ce026f6-ecf3-42c9-9aac-22405a393a18.jpg',
    alt: 'A row of bone paper tabs with a circular marker and one muted sage selection',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8523c6ab-6c82-4980-a1ea-227a27a6b913.jpg',
    alt: 'Two overlapping perforated paper strips with a black circle and muted blue edge',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/b23caa7a-21c7-41db-b6ce-bb0ca39d9fc6.jpg',
    alt: 'Overlapping matte bone cards with a black circle and muted brass detail',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5f24f939-74d5-4c00-947a-b8360fee4e59.jpg',
    alt: 'Four circular markers connected by black thread across a bone paper card',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e8a52db9-7c4d-45c2-bfd2-e85a15aa51f7.jpg',
    alt: 'Three folded paper channels carrying a black bead toward a muted sage endpoint',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/cb6446ad-b61d-46b1-bcd1-b4b7778b1686.jpg',
    alt: 'Two bone paper modules joined by a slim black connector with a muted terracotta junction',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/257c5027-2591-43c9-a732-3c9951b858a9.jpg',
    alt: 'A black token enclosed by raised pale paper walls with a muted plum edge',
  },
]
